import { useEffect, useRef } from 'react';

  // prevProps/PrevState helper function
  export default function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
}